import { type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    name: 'points',
    path: '/points',
    component: () => import('@pages/points/page/PointsPage.vue')
  },
  {
    name: 'analytics',
    path: '/analytics',
    component: () => import('@pages/analytics/page/AnalyticsPage.vue')
  },
  {
    name: 'finance',
    path: '/finance',
    component: () => import('@pages/finance/page/FinancePage.vue')
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('@pages/auth/login/LoginPage.vue')
  },
  {
    name: 'password-set-email',
    path: '/password-set-email',
    component: () => import('@pages/auth/set-new-password/email/SetNewPasswordEmailPage.vue')
  },
  {
    name: 'password-check-email',
    path: '/password-check-email',
    component: () => import('@pages/auth/check-email/CheckEmailPage.vue'),
    beforeEnter: (_, from, next) => {
      if (['password-set-email', 'settings'].every(routeName => routeName !== from.name)) {
        next({ name: 'login' })
        return
      }
      next()
    }
  },
  {
    name: 'set-password',
    path: '/set-password',
    component: () => import('@pages/auth/set-new-password/form-page/SetNewPasswordPage.vue')
  },
  {
    name: 'set-password-success',
    path: '/set-password-success',
    component: () => import('@pages/auth/set-new-password/success/SetNewPasswordSuccessPage.vue'),
    beforeEnter: (_, from, next) => {
      if (from.name !== 'set-password') {
        next({ name: 'login' })
        return
      }

      next()
    }
  },
  {
    name: 'dpkymeuwpmvb',
    path: '/dpkymeuwpmvb',
    component: () => import('@pages/reports/page/ReportPage.vue')
  }
]

export default routes
